import { QUESTION_NAMES } from 'client-portal/utils/prescreener/constants';
import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class PrescreenerValidationService extends Service {
  @service store;
  @service prescreener;

  validationModels = {};
  answers = {};

  @tracked forceValidation = false;

  getValidatedAnswerModel(question) {
    return (this.validationModels[question.name] ||= this.store.createRecord(
      'prescreener/answer-validation',
      question
    ));
  }

  updateAnswerModel(question, value) {
    const validationModel = this.getValidatedAnswerModel(question);
    validationModel.set('value', value);

    if (question.name === QUESTION_NAMES.INSURANCE_CARD_UPLOAD) return;
    this.answers[question.name] = value;
  }

  validateAll() {
    const allAnswers = Object.values(this.validationModels);
    this.forceValidation = true;
    return this.validateAnswerModels(allAnswers);
  }

  validateCurrentCategory(currentCategory) {
    if (!currentCategory) return true;

    this.forceValidation = true;

    const categoryAnswers = this.getAnswersForCategory(currentCategory);
    return this.validateAnswerModels(categoryAnswers);
  }

  getAnswersForCategory(category) {
    return Object.values(this.validationModels).filter(model => model.category === category);
  }

  validateAnswerModels(answerModels) {
    for (const answerModel of answerModels) {
      if (answerModel.validations.isInvalid) {
        return false;
      }
    }
    return true;
  }

  clearValidationModels() {
    this.validationModels = {};
    this.answers = {};
  }

  resetValidation() {
    this.forceValidation = false;
  }
}
